import { useRouterState } from '@tanstack/react-router';
import { cn } from '@/shared/lib/cn';
import {
  bottomNavClasses,
  bottomNavItemActiveClasses,
  bottomNavItemClasses,
} from '@/shared/layout/bottom-nav/styles';
import type { BottomNavProps } from '@/shared/layout/bottom-nav/types';

export function useBottomNavProps({ items, profileSlot }: BottomNavProps) {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return {
    navProps: { className: bottomNavClasses, 'aria-label': 'Primary mobile' },
    profileSlot,
    items: items.map((item) => {
      const active = pathname === item.to;
      return {
        key: item.to,
        to: item.to,
        icon: item.icon,
        label: item.label,
        linkProps: {
          className: cn(bottomNavItemClasses, active && bottomNavItemActiveClasses),
          'aria-current': active ? ('page' as const) : undefined,
        },
      };
    }),
  };
}
